<template>
  <div class="vh-100 active-screen">
    <div
      class="content"
      v-if="getActiveGameUser && getActiveGameUser.first_name"
    >
      <img
        class="brand-logo"
        src="@/assets/logo.svg"
        alt="Omroep West"
        width="280"
      />
      <h2 class="eyebrow">Nu aan de beurt</h2>
      <h1>
        {{ getActiveGameUser.first_name }},<br />
        <small>start je spel!</small>
      </h1>
    </div>
    <div class="content" v-else>
      <img
        class="brand-logo"
        src="@/assets/logo.svg"
        alt="Omroep West"
        width="280"
      />
      <h1>Spel actief</h1>
      <h2>Veel succes!</h2>
    </div>
  </div>
</template>

<script>
export default {
  name: "ActiveScreen",
  computed: {
    getActiveGameUser() {
      let activeGameUser = this.$store.getters.getActiveGameUser;
      return activeGameUser;
    },
  },
};
</script>

<style scoped>
.active-screen {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: #234d9d;
}

.content {
  padding: 48px 36px;
  max-width: 900px;
}

.brand-logo {
  margin-bottom: 26px;
}

h1 {
  font-size: 4.1rem;
  color: #ffffff;
  margin: 0;
  font-weight: 700;
}
h2 {
  font-size: 2rem;
  color: #ffffff;
  margin-bottom: 10px;
}

.eyebrow {
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-size: 1.15rem;
  color: #ffffff;
}

@media (max-width: 1200px) {
  h1 {
    font-size: 3rem;
  }

  h2 {
    font-size: 1.5rem;
  }

  .content {
    width: calc(100% - 32px);
    padding: 36px 24px;
  }
}

@media (min-height: 1920px) {
  h1 {
    font-size: 7rem;
  }

  h2 {
    font-size: 3.5rem;
  }

  .eyebrow {
    font-size: 2rem;
  }

  .brand-logo {
    width: 480px !important;
    margin-bottom: 40px;
  }

  .content {
    max-width: none;
    width: 90vw;
    padding: 80px 60px;
  }
}
</style>
